module.exports = __webpack_public_path__ + "img/volume-mute-fill.21fad946.svg";